/*
 * PROD-7828 — a file download asks for a Blob, so a refusal's JSON envelope arrives as a Blob too.
 * json_body is the pure half (text -> the envelope, {} when it is not JSON); with_json_error rewrites the
 * axios error so api_error and every tab's error router read it like any other refusal.
 */
export const json_body = (text) => {
  try {
    const v = JSON.parse(typeof text === 'string' ? text : '');
    return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  } catch (e) {
    return {};
  }
};

export const with_json_error = async (e) => {
  const data = e && e.response && e.response.data;
  if (!data || typeof data.text !== 'function') return e;
  const text = await data.text();
  return { ...e, response: { ...e.response, data: json_body(text) } };
};
